import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';
import { REFERRAL_PATHS } from './constants';

/** Les routes enfant React Router sont relatives : on retire le slash de tête. */
const toSegment = (path: string): string => path.replace(/^\//, '');

export const referralRoutes: RouteObject[] = [
  {
    path: toSegment(REFERRAL_PATHS.root),
    Component: Outlet,
    handle: { context: CONTEXTS.REFERRAL, title: 'Mon parrainage' },
  },
];
